import { FaInstagram, FaTiktok, FaEnvelope } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrolltoTop";
import scrollWithOffset from "../components/scrollWithOffset";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="footer-top-row">
          <div className="footer-column footer-logo-column">
            <Link to="/">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/logos/whiteLogo.webp"
                alt="whiteLogo"
                className="footer-logo"
                onClick={scrollToTop}
              />
            </Link>
          </div>
          <div className="footer-column text-column">
            <h4>Browse</h4>
            <Link to="/about" onClick={scrollToTop} aria-label="About us">
              About us
            </Link>
            <Link to="/events" onClick={scrollToTop} aria-label="Events">
              Events
            </Link>
            <Link to="/artists" onClick={scrollToTop} aria-label="Artists">
              Artists
            </Link>
            <Link to="/blog" onClick={scrollToTop} aria-label="Blog">
              Blog
            </Link>
          </div>
          <div className="footer-column text-column">
            <h4>Useful links</h4>
            <Link to="/gallery" onClick={scrollToTop}>
              Gallery
            </Link>
            <Link
              to="/events#eventsform"
              className="fflink"
              scroll={scrollWithOffset}
            >
              Feedback form
            </Link>
            <Link
              to="/events#reviews"
              className="fflink"
              scroll={scrollWithOffset}
            >
              Reviews
            </Link>
          </div>
          <div className="footer-column text-column">
            <h4>Get in touch</h4>
            <Link to="/contact" id="footer-contact" onClick={scrollToTop}>
              Contact us
            </Link>
            <div className="footer-icon-container">
              <Link to="mailto:management@wearedfg.com" aria-label="Email us">
                <FaEnvelope className="footer-icon" />
              </Link>
              <Link to="https://www.instagram.com/theafrocollective_?igsh=MTI2YXVybHd5MHUycg==" aria-label="Our Instagram">
                <FaInstagram className="footer-icon" />
              </Link>
              <Link to="https://www.tiktok.com/@theafrocollective?_t=ZG-8sKiwIgkxaC&_r=1" aria-label="Our Tiktok">
                <FaTiktok className="footer-icon" />
              </Link>
              <Link to="https://x.com/afrocollective_?s=21&t=-zqnoi5XgftC8eHr9Aeu1w" aria-label="Our Twitter">
                <FaXTwitter className="footer-icon" />
              </Link>
            </div>
          </div>
        </div>
        <hr />
        <span className="bottom-line">
          ©2024 The Afro Collective - Powered by{" "}
          <Link to="https://www.acrylicwebstudios.com">
            Acrylic Web Studios
          </Link>{" "}
          All rights reserved
        </span>
      </footer>
    </>
  );
};

export default Footer;
